module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-user"
  }, [(_vm.logined) ? _c('div', {
    staticClass: "user-info"
  }, [_c('i', {
    staticClass: "iconfont icon-user"
  }), _vm._v(" "), _c('a', {
    staticClass: "user-name",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.logOut
    }
  }, [_vm._v(_vm._s(_vm.userInfo.USER_NAME))]), _vm._v(" "), _c('div', {
    staticClass: "user-menu"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showChangePwd = true
      }
    }
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.logOut
    }
  }, [_vm._v("注销登录")])])]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增运送订单",
      "visible": _vm.showChangePwd,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.showChangePwd = $event
      }
    }
  }, [_c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "iconfont icon-dingdan"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "",
      "value": "",
      "placeholder": "新密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "iconfont icon-dingdan"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repassword),
      expression: "repassword"
    }],
    attrs: {
      "type": "password",
      "name": "",
      "value": "",
      "placeholder": "重复新密码"
    },
    domProps: {
      "value": (_vm.repassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showChangePwd = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveUserPwd
    }
  }, [_vm._v("保 存")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e324534","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components_bit/UserInfo.vue
// module id = 953
// module chunks = 1